// extracted by mini-css-extract-plugin
module.exports = {"editorsNote":"EditorsNote_editorsNote__1DWF3","content":"EditorsNote_content__usW8V","label":"EditorsNote_label__1hHp_"};